import { Auth } from "aws-amplify";

class GuruUtils {

  async apiDomain() {
    return "api.getguru.ai";
  }

  async checkAdmin(setIsAdmin) {
    Auth.currentAuthenticatedUser()
      .then((user) => {
        user.getUserAttributes((error, attributes) => {
          attributes.forEach((attribute) => {
            if (attribute["Name"] === "email") {
              setIsAdmin(
                attribute["Value"].endsWith("@getguru.fitness") ||
                  attribute["Value"].endsWith("@getguru.ai") ||
                  attribute["Value"].endsWith("@strangelooplabs.ai")
              );
            }
          });
        });
      })
      .catch((result) => {
        console.error(`Failed to fetch authenticated user: ${result}`);
      });
  }

  async getAuthHeaders() {
    const token = await this.getAuthToken();
    const headers = {
      Authorization: token,
    };

    const tenantOverride = this.getTenantOverride();
    if (tenantOverride) {
      headers["X-Tenant-Override"] = tenantOverride;
    }

    return headers;
  }

  async getAuthToken() {
    return (await Auth.currentSession()).getIdToken().getJwtToken();
  }

  getTenantOverride() {
    return window.sessionStorage.getItem("tenantOverride");
  }

  async isLoggedIn() {
    try {
      await Auth.currentAuthenticatedUser();
      return true;
    } catch {
      return false;
    }
  }

  clearTenantOverride() {
    window.sessionStorage.removeItem("tenantOverride");
  }

  setTenantOverride(tenantId) {
    window.sessionStorage.setItem("tenantOverride", tenantId);
  }

  async userHasTenant() {
    return (await this.userTenant()) !== null;
  }

  async userTenant() {
    const user = await Auth.currentAuthenticatedUser();

    if (
      user.signInUserSession.accessToken.payload["cognito:groups"] === undefined
    ) {
      return null;
    }

    const tenantGroup = user.signInUserSession.accessToken.payload[
      "cognito:groups"
    ].find((group) => {
      return group.startsWith("tenant-");
    });

    if (tenantGroup) {
      return tenantGroup.split("-")[1];
    } else {
      return null;
    }
  }
}

export const guruUtils = new GuruUtils();
